<campus-public-portal-not-found-hero class="[ flex items-center ]"></campus-public-portal-not-found-hero>

<div class="kabas-not-found__wrapper [ absolute top-1/2 left-m transform -translate-y-1/2 ] [ container p-m ]">
  <h1 class="[ m-bs-xl m-block-end-s ]">De weg kwijt?</h1>
  <div class="[ m-block-end-l ]">Misschien typte je een verkeerd adres of bestaat deze pagina niet meer. </div>

  <campus-button surface-button routerLink="/">Breng me terug naar aarde</campus-button>
</div>
